import { render, staticRenderFns } from "./FundCalc.vue?vue&type=template&id=510686d0&scoped=true&"
import script from "./FundCalc.vue?vue&type=script&lang=js&"
export * from "./FundCalc.vue?vue&type=script&lang=js&"
import style0 from "./FundCalc.vue?vue&type=style&index=0&id=510686d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510686d0",
  null
  
)

export default component.exports